<template>
  <img
    :src="gravatarUrl"
    class="avatar inline-block relative rounded-full"
    alt="avatar"
    :key="emailHash"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import md5 from "md5";

const props = withDefaults(
  defineProps<{ email?: string; emailHash?: string; size?: string }>(),
  {
    size: "25",
  }
);

const emailHash = computed(() => {
  if (props.emailHash) return props.emailHash;
  const primaryEmail = props.email;
  if (primaryEmail) {
    return md5(primaryEmail);
  }
  return undefined;
});

const gravatarUrl = computed(() => {
  return `https://www.gravatar.com/avatar/${emailHash.value}?s=${props.size}&d=identicon`;
});
</script>

<style scoped></style>
